@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.wrapper {
  margin-top: @space-24;
}

.payment-styling {
  > div {
    padding: 0 @space-16;
  }

  svg {
    color: var(--gray-637381);
  }
}

.payment-form-container {
  padding: @space-16;
  margin: @space-16;
  margin-top: 0;
  background-color: var(--grey-100);
  border: 1px solid var(--blue-11003A);
  border-radius: 8px;
}

.checkbox {
  font-size: 14px;
}

.tooltip {
  width: 16px;
}
